import { render } from "./ExchangeAddFundsInfo.vue?vue&type=template&id=31815b7e"
import script from "./ExchangeAddFundsInfo.vue?vue&type=script&lang=js"
export * from "./ExchangeAddFundsInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__